import { createContext, useContext } from 'react';
export const FormContext = createContext({
    useValidationIcon: true,
});
export const FormContextProvider = FormContext.Provider;
export const useFormContext = () => useContext(FormContext);
//# sourceMappingURL=FormContext.js.map